function App({ children }) {
  return <main className="app">{children}</main>;
}

export default App;
